import { registerPreprocessor } from 'echarts';
import { MOBILE_QUERY } from './mobile';

/**
 * Telefon: dymki wszystkich wykresów ECharts trzymają się w obrębie wykresu (`confine`), zamiast
 * wyjeżdżać poza ekran. Preprocesor działa przy KAŻDYM `setOption` każdego wykresu, więc nie trzeba
 * pilnować tego w kilkudziesięciu konfiguracjach — a na desktopie opcje zostają nietknięte.
 */
registerPreprocessor((option) => {
  if (!window.matchMedia(MOBILE_QUERY).matches || !option.tooltip) {
    return;
  }
  const tooltips = Array.isArray(option.tooltip) ? option.tooltip : [option.tooltip];
  tooltips.forEach((tooltip) => {
    tooltip.confine = true;
  });
});
